// import react, {useState} from 'react';
import CustomerLayout from './CustomerLayout';
import Customers from './Customers'

import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText,   Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, } from '@mui/material';
  import WithAuth from './WithAuth';


function MergeCustomers() {
  const [merge, setMerge] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false); // Dialog visibility state
  const [customers, setCustomers] = useState([]); // Fetched data state


  const handleMergeMany = async (mergeFormData, checkedRows) => {
    console.log('Merging rows:', checkedRows);
    console.log('Merge form Data: '+JSON.stringify(mergeFormData))
    const confirmMerge = window.confirm(`Are you sure you want to merge selected customers?`);

    if (!confirmMerge) {
      return; 
    }
    // try{
    //   await addMergedCustomer(mergeFormData);
    // }
    // catch(e){
    //   alert('Error Merging Customers')
    // }

    try {
      const response = await fetch(process.env.REACT_APP_API_URL + '/api/customers/merge', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
        },
        body: JSON.stringify({ deleteIds: checkedRows, newCustomerData: mergeFormData }), // Convert checkedRows to a JSON string
      });

      if (!response.ok) {
        throw new Error('Failed to merge rows');
      }

      const data = await response.json(); // Get response data from the server
      alert('Selected customers merged successfully!');
      console.log('Merge successful:', data);

      // Fetch the merged customers' data
      const id = checkedRows[0] // Replace with the actual merge ID from the server response
      fetch(process.env.REACT_APP_API_URL + `/api/customers/mergeId/${id}`)
        .then((response) => response.json())
        .then((data) => {
          console.log('Fetched merged customers:', data);
          setCustomers(data); // Set the fetched data
          // setDialogOpen(true); // Show the dialog
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });

    } catch (error) {
      console.error('Error merging rows:', error);
      alert(`Failed to merge customers: ${error.message}`);
    }
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCustomers([]);
  };

  return (
    <div>
      <Customers header={'Merge Customers'} merge={merge} setMerge={setMerge} handleMergeMany={handleMergeMany} />

      {/* Material-UI Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog} fullWidth maxWidth="lg">
        <DialogTitle>Merged Customers</DialogTitle>
        <DialogContent>
        <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email(s)</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>School</TableCell>
                  <TableCell>Upload ID</TableCell>
                  <TableCell>City</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customers.map((customer, index) => (
                  <TableRow key={index}>
                    <TableCell>{customer.name || 'N/A'}</TableCell>
                    <TableCell>{customer.emailIds?.join(', ') || 'N/A'}</TableCell>
                    <TableCell>{customer.role || 'N/A'}</TableCell>
                    <TableCell>{customer.school || 'N/A'}</TableCell>
                    <TableCell>{customer.uploadId || 'N/A'}</TableCell>
                    <TableCell>{customer.city || 'N/A'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default WithAuth(MergeCustomers);
